module.exports = __webpack_public_path__ + "img/9-11-24.96c0a99b.jpg";